/**
 * NOTICE : This HOC will soon be deprecated.
 * You should not use this HOC for any future components.
 */

import * as React from "react";
import { BrowserRouter, StaticRouter, useLocation } from "react-router-dom";
import { StaticRouterProps } from "react-router";
import { PropsAreEqual } from ".";

const Debugger = () => {
  const location = useLocation();

  return <pre>{JSON.stringify(location)}</pre>;
};

export const withInjectedRouter = <Props extends {} & StaticRouterProps>(
  Component: {
    (props: Omit<Props, keyof StaticRouterProps>): Exclude<
      JSX.Element,
      undefined
    >;
    displayName?: string;
  },
  propsAreEqual?: PropsAreEqual<Props> | false,

  componentName = Component.displayName ?? Component.name
) => {
  return (props: Props): JSX.Element => {
    const { location, basename, context, ...rest } = props;

    React.useEffect(() => {
      console.warn(
        "[DEPRECATION NOTICE] withInjectedRouter will soon be deprecated next major. Avoid using this HOC."
      );
    }, []);

    if (typeof window === "undefined") {
      return (
        <StaticRouter location={location} basename={basename} context={context}>
          {/* <Debugger /> */}
          <Component {...rest} />
        </StaticRouter>
      );
    }

    return (
      <BrowserRouter>
        <Component {...rest} />
      </BrowserRouter>
    );
  };
};
